export enum RingSearchEntityType {
  PROFILE = 'profile',
  PAGE = 'page',
}

export enum RingSearchFacet {
  TYPE = 'f_type',
  BRAND = 'f_brand',
  PRODUCT = 'f_product',
  CATEGORY = 'f_category',
  SECTION = 'f_section',
}

export interface IRingSearchPayload {
  url: string;
  lastmod?: string | null;
  title?: string | null;
  description?: string | null;
  publisher?: string | null;
  iconUrl?: string | null;
  logoUrl?: string | null;
  profileType?: string | null;
  certifiedBadge?: boolean | null;
  partnerBadge?: string | null;
}

export interface IRingSearchItemFilter {
  name: string;
  itemNames: string[];
}

export interface IRingSearchItem {
  type: string;
  id: string;
  score: number;
  payload: IRingSearchPayload;
  filters: IRingSearchItemFilter[];
}

export interface IRingSearchPagination {
  pageNumber: number;
  pageItems: number;
  totalItems: number;
}

export interface IRingSearchContent {
  durationSearch?: number;
  filters?: IRingSearchItemFilter[];
  items: IRingSearchItem[];
  pagination?: IRingSearchPagination;
  queryInput?: string;
  querySanitized?: string | null;
}

export interface IRingSearchEnvelope {
  statusCode: number;
  charset?: string;
  message?: string | null;
  content: IRingSearchContent | null;
  requestId?: string;
}

export interface IRingSearchRequestBody {
  appId: string;
  pipeline: 'appGallery';
  query: string;
  [RingSearchFacet.TYPE]: RingSearchEntityType[];
  [RingSearchFacet.BRAND]: string[];
  [RingSearchFacet.PRODUCT]?: string[];
  [RingSearchFacet.CATEGORY]?: string[];
  [RingSearchFacet.SECTION]?: string[];
  pageNumber: number;
  pageItems: number;
  wrapperStart: string;
  wrapperEnd: string;
}
